/**
 * @doc module
 * @id GraphComment
 * @description GraphComment
 *
 */
angular.module('GraphCommentModule', [
'services.comments',
'gc.user',
'gc.share',
'gc.perfs',
'gc.auth-popin',
'gc.ban-popin',
'gc.ng-repeat-done',
'gc.profile-popin',
'ui-rangeSlider',
'service.GcECD',
'ng',
])
.constant('version', '0.1')
.constant('TMP_ID', 'XXXXtmpID')
/**
* @doc directive
* @id GraphComment:graphcomment
*
* @description Graphcomment main Controller
*/
.controller('GraphcommentController', [
'$scope',
'$element',
'$rootScope',
'$log',
'$http',
'$location',
'$timeout',
'$document',
'$translate',
'$filter',
'GcUser',
'BASE_URL',
'CommentService',
'ShareService',
'SliderService',
'FocusService',
'LanguageUtils',
'LocalStorageService',
'PubService',
'API_URL',
'Perfs',
'Utils',
'PostMessageService',
'Notifs',
'WS',
'GraphLogin',
function ($scope, $element, $rootScope, $log, $http, $location, $timeout, $document, $translate, $filter,
GcUser, BASE_URL, CommentService, ShareService, SliderService, FocusService, LanguageUtils, LocalStorageService, PubService, API_URL, Perfs, Utils,
PostMessageService, Notifs, WS, GraphLogin) {

  'use strict';

  window.CommentService = CommentService;
  window.Utils = Utils;

  SliderService.init();

  $rootScope.ecd_creation_mode = false;
  $rootScope.fixedHeaderHeight = 0;
  $rootScope.votePopin = {};
  $rootScope.iframeScroll = { pos: { top: 0, left: 0 }, win: { width: 0, height: 0 } };
  $rootScope.isWidget = Utils.getParameterByName('widget') && Utils.getParameterByName('widget') === 'true';
  $rootScope.Utils = Utils;

  $scope.GcUser = GcUser;
  $scope.voteIcon = Utils.voteIcon;
  $rootScope.searchMode = false;
  $scope.searchClass = "";
  $rootScope.disableTrackingOnLogout = false;


  $rootScope.getMotifs = function() {
    var motifs = {};
    for (var i = 0; i <= 24; i++) {
      motifs[i] = $translate.instant('motif_' + i);
    }
    motifs[99] = $translate.instant('motif_99');
    return motifs;
  };


  $rootScope.getWebsiteLang = function() {
    return $rootScope.lang === 'fr' ? 'fr' : 'en';
  };

  /**
   * Popup need more space
   * @type {boolean}
   */

  $scope.mainColorClass = {};


  /**
   * Toggle sort help message
   */
  var showHelpPromise;
  $scope.isSortHelpActive = false;
  $scope.toggleSortHelp = function () {
    $scope.isSortHelpActive = !$scope.isSortHelpActive;
    $timeout.cancel(showHelpPromise);
  };
  $scope.enterSortHelp = function () {
    showHelpPromise = $timeout(function () {
      $scope.isSortHelpActive = true;

      $document.on('mouseover', function (event) {
        if (event) {
          event.stopPropagation();
        }
        var profile = document.querySelector('.gc-help-sort-content');
        if (profile && profile.contains(event.target)) {
          return;
        }
        $document.off('mouseout');
        $timeout(function () {
          $scope.isSortHelpActive = false;
        }, 20, true);
      });
    }, 50, true);
  };
  $scope.leaveSortHelp = function () {
    $timeout.cancel(showHelpPromise);
  };

  /**
   * Deal with infinite scroll (no server request, but inserting in DOM 10 by 10)
   */
    // Hot fix: We can't use trigger scroll inside an iframe without scrollbar.
    // The limit was 10, i push the limit to 999999.
  $scope.countPerPage = 0;

  $scope.showGuestPopup = function (event) {
    event.preventDefault();
    var guest = GcUser.getGuest();
    $rootScope.$broadcast('show:popup', {
      page: 'guest',
      data: {
        username: guest && guest.username,
        email: guest && guest.email,
      }
    });
  };

  $scope.showSigninPopup = function (event) {
    $rootScope.$broadcast('show:popup', { page: 'signin', target: event.target });
  };

  $scope.showSignupPopup = function (event) {
    $rootScope.$broadcast('show:popup', { page: 'signup', target: event.target });
  };

  $scope.manageSpupPseudo = function() {
    $rootScope.spupLog('[spup] click "manage pseudo"');
    var website = CommentService.website;
    if(website.custom_client_login === true) {
      window.parent.postMessage({"target": "spup", "command": "manage", "params": []}, '*');
      //window.parent.oSpup.manage();
    }
  };

  // save console.log() from spup for further debugging
  var spupLogs = [];
  var spupLog = $rootScope.spupLog = function() {
    if (CommentService.website && CommentService.website.custom_client === 'orange') {
      console.log.apply(console, arguments);
      spupLogs.push(Array.prototype.slice.call(arguments));
    }
  }

  $scope.debugSpup = function() {
    $scope.spupPopinOpen = true;

    var logs = [
      'browser: ' + window.navigator.userAgent,
      'OS: ' + window.navigator.platform,
      'spup user: '+ JSON.stringify($rootScope.orangeUser),
      'graphcomment user: ' + JSON.stringify(GcUser.getUser()),
      'graphcomment version: ' + window.gcVersion,
      '-------------',
      'informations for the developper:',
      ''
    ];

    spupLogs.forEach(function(log) {
      logs.push(
        log.map(l => typeof l === 'object' ? JSON.stringify(l) : l).join('\r\n')
      );
    });

    return logs.join('\r\n');
  }

  $scope.sendSpupReport = function(spupReportNumber, skipConfirm) {
    var $field = $('.spup-report-number');
    spupReportNumber = spupReportNumber || $field.val();

    if (/^gc?[0-9]+$/.test(spupReportNumber)) {
      $field.removeClass('ng-invalid').addClass('ng-valid');
      $http.post(BASE_URL + '/api/pub/sendSupportEmail', {
        content: $scope.debugSpup(),
        ticketNumber: spupReportNumber,
      }).success(function(resp) {
        mixpanel.track('orange:spup_report');
        if (!skipConfirm) alert($translate.instant('spup report success'));
        $scope.spupPopinOpen = false;
      });
    } else {
      alert($translate.instant('spup report error') + ' ' + spupReportNumber);
      $field.removeClass('ng-valid').addClass('ng-invalid');
    }
  };

  $scope.selectLogs = function() {
    var el = $element.find('.gc-popin--spup pre')[0];
    var range = document.createRange();
    range.selectNodeContents(el);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  };

  $scope.closeSpupPopin = function() {
    $scope.spupPopinOpen = false;
  };

  // oSpup (for orange)
  $rootScope.$on('thread', function(e, thread) {
    var website = CommentService.website;
    //document.domain = 'orange.fr';
    if (website.custom_client === 'orange') {

      //document.domain = 'orange.fr';
      //spupLog('[spup] init', typeof window.parent.oSpup);

      // ospup
      $timeout(function() {
        //window.parent.oSpup.removeAllListeners();
        var initialRead = true;
        spupLog('[spup] register event listeners');
        const isTrustedOrigin = function(origin) {
          // Cette regex correspond à 'https://*.orange.fr' et 'https://*.orange.com'
          const pattern = /^https:\/\/([a-zA-Z0-9-]+\.)*orange\.(fr|com)$/;
          return pattern.test(origin);
        };

        // Pour écouter les messages venant de la fenêtre parente
        window.addEventListener('message', function(event) {
          // Toujours vérifier l'origine pour des raisons de sécurité
          if (!isTrustedOrigin(event.origin)) {
            console.error('Origine non autorisée:', event.origin);
            return; // Ignorez les messages d'origines non fiables
          }

          // Traiter le message reçu
          var l_oData = event.data;
          if (l_oData.source && l_oData.source === 'spup') {
            var l_hCallback = window['on' + l_oData.event.charAt(0).toUpperCase() + l_oData.event.slice(1)];
            if (typeof l_hCallback === 'function') {
              l_hCallback.apply(window, [l_oData.data]);
            }
          }
        }, false);

        /*window.parent.oSpup.addListener('created', function(event) {
          spupLog('[spup][created] event received', event.data);
          $rootScope.orangeUser = event.data;
          if ($rootScope.orangeUser && $rootScope.orangeUser.id !== -1) {
            spupLog('[spup][created] register');
            GcUser.registerSpup($rootScope.orangeUser);
          }
        });*/

        window.onCreated = function(data) {
          spupLog('[spup][created] event received', data);
          $rootScope.orangeUser = data;
          if ($rootScope.orangeUser && $rootScope.orangeUser.id !== -1) {
            spupLog('[spup][created] register');
            GcUser.registerSpup($rootScope.orangeUser);
          }
        };

        window.onRead = function(data) {
          $rootScope.orangeUser = data;

          // if current spup user has username/email that matches
          var spupUsersToDebug = $translate.instant('spup.users').replace(/ /g, '').split(',') || [];
          if (
              spupUsersToDebug.indexOf($rootScope.orangeUser.name) !== -1 ||
              spupUsersToDebug.indexOf($rootScope.orangeUser.email) !== -1
          ) {
            // we automatically send spup rapport after a certain time
            setTimeout(function() {
              $scope.sendSpupReport('gc' + $rootScope.orangeUser.id, true);
            }, 10 * 1000);
          }

          spupLog('[spup] read');
          spupLog('[spup] token:', GcUser.getToken());
          spupLog('[spup] orangeUser:', $rootScope.orangeUser);
          spupLog('[spup] gcUser:', GcUser.getUser());

          // invalid token
          if (GcUser.getToken() && !GcUser.getUser()) {
            spupLog('[spup] invalid token');
            LocalStorageService.removeToken();
            GcUser.registerSpup($rootScope.orangeUser);
            return;
          }

          // test if user has switched accounts
          if ($rootScope.orangeUser && GcUser.getUser() && $rootScope.orangeUser.name !== GcUser.getUser().pseudo) {
            spupLog('[spup] switched account');
            LocalStorageService.removeToken();
            GcUser.registerSpup($rootScope.orangeUser);
            return;
          }

          // auto-posting, when posting a comment, if the user is not authenticated
          // he/she is redirected to login.orange.fr, after successful authentication
          // we post his/her comment.
          if ($rootScope.orangeUser && $rootScope.orangeUser.id !== -1) {
            var savedComment = CommentService.getSavedComment();
            spupLog('[spup] saved comment', savedComment);
            if (savedComment) {
              var unbind = $rootScope.$on('spup_registered', function() {
                spupLog('[spup] post saved comment', savedComment);
                CommentService.postSavedComment();
                $rootScope.$broadcast('reset_write_comment');
                unbind();
              });
              GcUser.registerSpup($rootScope.orangeUser);
            }
          }

          if (!GcUser.getToken()) {
            // if there's a logged-in user
            if ($rootScope.orangeUser && $rootScope.orangeUser.id !== -1) {
              spupLog('[spup] spup get token');
              // get token
              GcUser.registerSpup($rootScope.orangeUser);
            }
            // if no user we create a new pseudo
            else if (!initialRead) {
              $timeout(function() {
                spupLog('[spup] spup create pseudo');
                //window.parent.oSpup.create();
                window.parent.postMessage({"target": "spup", "command": "create", "params": []}, '*');
                // dirty fix
                $rootScope.$broadcast('call_reset_spup_comment');
              }, 0);
            } else {
              $timeout(function() {
                spupLog('[spup] spup create pseudo');
                //window.parent.oSpup.create();
                window.parent.postMessage({"target": "spup", "command": "create", "params": []}, '*');
                // dirty fix
                $rootScope.$broadcast('call_reset_spup_comment');
              }, 0);
            }
          } else {
            spupLog('[spup] has token');
            $rootScope.$broadcast('spup_registered');
          }

          if (initialRead) initialRead = false;
        };

        /*
        window.parent.oSpup.addListener('read', function(event) {
          $rootScope.orangeUser = event.data;

          // if current spup user has username/email that matches
          var spupUsersToDebug = $translate.instant('spup.users').replace(/ /g, '').split(',') || [];
          if (
            spupUsersToDebug.indexOf($rootScope.orangeUser.name) !== -1 ||
            spupUsersToDebug.indexOf($rootScope.orangeUser.email) !== -1
          ) {
            // we automatically send spup rapport after a certain time
            setTimeout(function() {
              $scope.sendSpupReport('gc' + $rootScope.orangeUser.id, true);
            }, 10 * 1000);
          }

          spupLog('[spup] read');
          spupLog('[spup] token:', GcUser.getToken());
          spupLog('[spup] orangeUser:', $rootScope.orangeUser);
          spupLog('[spup] gcUser:', GcUser.getUser());

          // invalid token
          if (GcUser.getToken() && !GcUser.getUser()) {
            spupLog('[spup] invalid token');
            LocalStorageService.removeToken();
            GcUser.registerSpup($rootScope.orangeUser);
            return;
          }

          // test if user has switched accounts
          if ($rootScope.orangeUser && GcUser.getUser() && $rootScope.orangeUser.name !== GcUser.getUser().pseudo) {
            spupLog('[spup] switched account');
            LocalStorageService.removeToken();
            GcUser.registerSpup($rootScope.orangeUser);
            return;
          }

          // auto-posting, when posting a comment, if the user is not authenticated
          // he/she is redirected to login.orange.fr, after successful authentication
          // we post his/her comment.
          if ($rootScope.orangeUser && $rootScope.orangeUser.id !== -1) {
            var savedComment = CommentService.getSavedComment();
            spupLog('[spup] saved comment', savedComment);
            if (savedComment) {
              var unbind = $rootScope.$on('spup_registered', function() {
                spupLog('[spup] post saved comment', savedComment);
                CommentService.postSavedComment();
                $rootScope.$broadcast('reset_write_comment');
                unbind();
              });
              GcUser.registerSpup($rootScope.orangeUser);
            }
          }

          if (!GcUser.getToken()) {
            // if there's a logged-in user
            if ($rootScope.orangeUser && $rootScope.orangeUser.id !== -1) {
              spupLog('[spup] spup get token');
              // get token
              GcUser.registerSpup($rootScope.orangeUser);
            }
            // if no user we create a new pseudo
            else if (!initialRead) {
              $timeout(function() {
                spupLog('[spup] spup create pseudo');
                //window.parent.oSpup.create();
                window.parent.postMessage({"target": "spup", "command": "create", "params": []}, '*');
                // dirty fix
                $rootScope.$broadcast('call_reset_spup_comment');
              }, 0);
            } else {
              $timeout(function() {
                spupLog('[spup] spup create pseudo');
                //window.parent.oSpup.create();
                window.parent.postMessage({"target": "spup", "command": "create", "params": []}, '*');
                // dirty fix
                $rootScope.$broadcast('call_reset_spup_comment');
              }, 0);
            }
          } else {
            spupLog('[spup] has token');
            $rootScope.$broadcast('spup_registered');
          }

          if (initialRead) initialRead = false;
        });
        */

        // logout if no 'wassup' cookie
        GcUser.hasSpupCookie().then(function(resp) {
          if (!resp.data.wassup) {
            spupLog('[spup] no wassup cookie, logout', resp.data);
            $rootScope.disableTrackingOnLogout = true;
            GcUser.logout(true);
          }
        });

      }, 0);
    }
  });


  $scope.viewProfile = function (params) {
    $scope.openProfilePopin(null, GcUser.getUser()._id, { fromMenu: true });
  };

  $scope.viewComments = function() {
    $scope.openProfilePopin(null, GcUser.getUser()._id, { fromMenu: true, fullProfile: true, tab: 'comments' });
  };

  $rootScope.$on('profile-popin:open', function(event, userId, params) {
    $scope.openProfilePopin(null, userId, params);
  });

  var tracked = {};
  $scope.trackOnce = function(eventName) {
    if (!tracked[eventName]) {
      mixpanel.track(eventName);
      tracked[eventName] = true;
    }
  }

  /**
   * Method that submits answers to the thread. Look over GcWriteComment.js for more information
   * about how the submit flow is managed.
   *
   * @param data
   */
  $scope.addComment = function (data) {
    return CommentService.addMessage(data);
  };

  $scope.editComment = function (data) {
    return CommentService.updateMessage(data);
  };

  /** Account popin
   * -----------------
   */

  $rootScope.openAccountPopin = function (event) {
    $rootScope.popin.account = true;
  };

  $rootScope.openPrefsPopin = function (event) {
    $scope.openProfilePopin(null, GcUser.getUser()._id, { fromMenu: true, fullProfile: true, tab: 'preferences' });
  };

  /**
   * Profile popin service
   */

  $rootScope.popin = {};

  var bodyMargin = parseInt(getComputedStyle(document.querySelector('.gc-body'))['padding-left'], 10);
  var bodyBox = document.querySelector('.gc-body').getBoundingClientRect();

  $rootScope.openProfilePopin = function (event, userId, params) {
    if (!userId) return; // ignore guests

    if (!params || !params.fromMenu) {
      var parent = $(event.target).parents('.gc-message');
      if (!parent.length) parent = $(event.target).parents('.gc-node');
      var pos = parent.find('.gc-avatar')[0].getBoundingClientRect();
    }

    $timeout(function() {
      var scroll = Utils.getScrollPosition();
      $rootScope.popin.profile = Object.assign({
        userId,
        offset: pos ? {
          left: !$rootScope.rtl && (window.innerWidth <= 500 ? 0 : pos.right - bodyBox.left + scroll.left + 10 + 'px'),
          right: $rootScope.rtl && (window.innerWidth <= 500 ? 0 : window.innerWidth - pos.left + scroll.left + 10 + 'px'),
          top: pos.top + scroll.top - 18 + 'px',
        } : {},
      }, params);
     
    }, 0);
    
  };

  $rootScope.closeProfilePopin = function() {
    $rootScope.popin.profile = null;
  };

  $rootScope.toggleProfilePopin = function (event, userId) {
    if ($rootScope.popin.profile) $rootScope.closeProfilePopin();
    else $rootScope.openProfilePopin(event, userId);
  };

  var profilePopinTimeout;
  $rootScope.openProfilePopinTimer = function (event, userId, time) {
    profilePopinTimeout = $timeout(function () {
      $scope.openProfilePopin(event, userId);
    }, time);
  };

  $rootScope.cancelProfilePopinTimer = function () {
    if (profilePopinTimeout) {
      $timeout.cancel(profilePopinTimeout);
      profilePopinTimeout = null;
    }
  };


  /**
   * Share popin
   */


  $scope.sharer = function (network) {
    ShareService.openShareWindow(network, $scope.short_url);
  };

  /**
   * Share function for ECD.
   *
   * @param event
   * @param ecd
   */
  $scope.shareDiscussion = function (event, ecd) {
    mixpanel.track('ecd:share');

    $rootScope.popinShare = {
      placement: event.target,
      comment: ecd.comments[ecd.comments.length - 1].comment,
    };
  };

  function scrollToComment(commentId, params = {}) {
    var offset = params.offset || 0;
    var timeout = params.timeout || 0;
    var skipFocus = params.skipFocus || false;

    if (!CommentService._comments[commentId]) {
      console.error('comment %s not found, %s comments', commentId, CommentService.comments.length);
      return;
    }

    // load all embeds before last comment read
    for (let comment of CommentService.comments) {
      if (comment._id === commentId) break;
      $rootScope.$emit('embeds:load:' + comment._id);
    }

    $timeout(function () {

      // we add a timeout in case there're lot of comments and it's lagging
      $timeout(function() {
        var scrollToEl = $('#comment-' + commentId);
        offset = offset || 0;
        offset += scrollToEl.offset().top;
        $scope.$emit('scrollTo', offset - $rootScope.fixedHeaderHeight); // we remove a few pixels in case there's a fixed header (like LePhoceen)
        console.debug('[gc] scroll comment %s %s px', '#comment-' + commentId, offset);
      }, 0);

      $timeout(function () {
        if (skipFocus) return;
        angular.element(document.body).removeClass('no-transition');
        var rootComment = CommentService.getRootComment(commentId);
        FocusService.activate(rootComment._id);
        $rootScope.$emit('yakli-link-scroll-done');
      }, 800 + 1000); // 800ms for scroll duration, 1000ms for margin of error

    }, timeout); // wait for everytihng to be rendered
  }

  // once all comments are loaded
  $rootScope.$on('gc:ready', function() {
    Perfs.measure('xhr');

    var yakli = Utils.getParameterByName('comment_id');
    if (yakli && !$rootScope.isWidget) {
      var root = CommentService.getRootComment(yakli);
      scrollToComment(root._id, { timeout: 1000 });
    } else {
      angular.element(document.body).removeClass('no-transition');
    }
  });

  /**
   * Show target ECD
   */
  $scope.ecd_comments = [];
  $scope.showEcd = function (ecd) {
    var ecdCmt = ecd.comments[ecd.comments.length - 1].comment;
    CommentService.populate(ecdCmt._id).then(function() {
      scrollToComment(ecdCmt._id, { timeout: 1000 });
    });
  };

  // Set user when he logs in
  $rootScope.$on('logged_in', function () {
    $scope.connectedUser = GcUser.getUser();
    if ($scope.connectedUser !== null) {
      LanguageUtils.updateUILanguage();
    }
    CommentService.postSavedComment();
  });

  $rootScope.$on('logged_out', function () {
    $scope.connectedUser = null;
  });

  $rootScope.ssoUnidirectionalEnabled = function() {
    return $rootScope.website.sso && $rootScope.website.sso.active && $rootScope.website.sso.unidirectional;
  };

  /**************************************************
   * Analytics Show Pop up                          *
   **************************************************/

  $rootScope.$on('logged_in', function () {
    var usr = GcUser.getUser();
    if (usr) {
      // after the alias, the mixpanel user can be identify by gc id
      // timeout to wait mixpanel to be set
      $timeout(function() {
        mixpanel.identify(usr._id);
        mixpanel.people.set(_.pick(usr, [
          'email',
          'created_at',
          'username',
          'pro_status',
          'google_id',
          'facebook_id',
          'twitter_id'
        ]));
      });
    }
  });


  $rootScope.$on('lang:change', function(event, lang) {
    $scope.supportLink = lang === 'fr'
      ? 'https://support.graphcomment.com/hc/fr-fr/community/topics/360000683340-Bug-Reports-Feedback/'
      : 'https://support.graphcomment.com/hc/en-us/community/topics/360000683340-Bug-Reports-Feedback'
    ;
  });

  $rootScope.$on('website', function() {
    $scope.rssLink = API_URL + '/rss/' + CommentService.website.public_key;
  });


  // readonly
  // ---------------------

  function isReadonly() {
    var readonly = Utils.getParameterByName('readonly');
    if (!readonly) return false;
    return readonly === 'false' ? false : true;
  }

  $rootScope.readonly = false;

  $rootScope.$on('website', function() {
    if (CommentService.website.rights !== 'free') {
      $rootScope.readonly = isReadonly();
    } else {
      if (isReadonly()) {
        console.error('[gc] readonly only for paid accounts');
      }
    }
  });


  // ads
  // --------

  $rootScope.$on('website', function() {
    // remove ads in standalone mode, and on gc.com domain
    //if (!Utils.inIframe() && /graphcomment\.com$/.test(window.location.host)) return;
    var ads = CommentService.website.ads;
    
    if (!ads || !ads.header || !ads.header.content || !ads.header.active) return;
    $rootScope.hasAds = true;
    
    var div = document.createElement('div');
    $(div).html(ads.header.content);

    var scripts = div.querySelectorAll('script');
    for (var i = 0; i < scripts.length; i++) {
      var script = scripts[i];
      if (script.src) {
        Utils.appendScript(script.src);
      } else {
        var $script = document.createElement('script');
        $($script).html(script.innerHTML);
        document.head.appendChild($script);
      }
    }
  });

  $rootScope.getAd = function(adIndex) {
    if (typeof adIndex === 'number') adIndex++; // one-indexed instead of zero-indexed

    if (!this._adCache) this._adCache = {};
    if (typeof this._adCache[adIndex] !== 'undefined') return this._adCache[adIndex];

    if (Utils.getParameterByName('disable_ads') === 'true') return;

    var ads = CommentService.website.ads;
    if (!ads) return;

    var ad = ads[Utils.inApp() || Utils.isMobile() ? 'mobile' : 'responsive'];
    if (!ad.active) return;

    var content = ad.content
      .replace(/\{\{\s?adIndex\s?\}\}/g, adIndex)
      .replace(/\{\{\s?url\s?\}\}/g, Utils.getParameterByName('url'))
    ;

    this._adCache[adIndex] = '<div>' + content + '</div>';
    return this._adCache[adIndex];
  };

  window.gcDebugAds = function() {
    CommentService.website.ads = {
      mobile: { active: true, content: 'Mobie Ad' },
      responsive: { active: true, content: 'Ad' },
    };
    $scope.$apply();
  };


  // Sorting
  // --------

  var sortingLabels;

  $scope.initSorting = function(user) {

    var sorting = LocalStorageService.getItem('sorting_' + Utils.getUniqueUrlIdentifier());
    if (user && !sorting) sorting = user.sort;
    if (!sorting) sorting = Utils.getParameterByName('sort') || CommentService.website.graphcomment.sort;

    $scope.sorting = $rootScope.sorting = sorting;
    $scope.sortingLabel = sortingLabels[$scope.sorting];

    if ($scope.sorting !== 'newest') {
      var unbind = $rootScope.$on('thread', function(e, thread) {
        // in case we load the page on a sorting other than 'newest',
        // when we switch to 'newest' sorting, we init lastCommentRead
        if ($scope.sorting === 'newest') {
          if (!$rootScope.lastCommentRead && thread.child_comments.length) {
            $rootScope.lastCommentRead = thread.child_comments[0]._id;
            LocalStorageService.setItem('last_comment_read_' + thread._id, $rootScope.lastCommentRead);
          }
          unbind();
        }
      });
    }
  }

  function getSortingLabels() {
    $translate(['sort by relevance', 'oldest', 'newest']).then(function(trans) {
      sortingLabels = {
        relevance: trans['sort by relevance'],
        oldest: trans['oldest'],
        newest: trans['newest'],
      };
      $scope.sortingLabel = sortingLabels[$scope.sorting];
    });
  }

  getSortingLabels();
  $rootScope.$on('lang:change', getSortingLabels);

  $scope.showSortTooltip = function(event) {
    event.preventDefault();
    $scope.sortTooltipVisible = !$scope.sortTooltipVisible;
  };

  $document.on('click', function(event) {
    var $sort = document.querySelector('.gc-headerItem-sort-container');
    if ($sort && !$sort.contains(event.target)) {
      $scope.sortTooltipVisible = false;
      $scope.$apply()
    }
  });

  $scope.setSort = function(sorting) {

    if ($scope.sorting === sorting && !$rootScope.yakli) return;

    $scope.sorting = $rootScope.sorting = sorting;
    $scope.sortingLabel = sortingLabels[sorting];
    $scope.sortTooltipVisible = false;
    LocalStorageService.setItem('sorting_' + Utils.getUniqueUrlIdentifier(), sorting);

    mixpanel.track('comment:sort', { sorting });
    if ($scope.sorting !== 'newest') $scope.resetLastCommentRead();
    CommentService.resetAll();
    $scope.reloadAllComments();
  };

  $scope.toggleLiveMode = function() {
    $scope.liveMode = !$scope.liveMode;
    CommentService.setSort($scope.liveMode ? 'newest' : 'relevance');
  };

  var unbind = $rootScope.$on('thread', function(event, thread) {
    $scope.liveMode = (thread.sort === 'newest');

    if ($scope.liveMode) {
      $scope.sorting = $rootScope.sorting = 'newest';
      $scope.sortingLabel = sortingLabels[$scope.sorting];
    }

    unbind(); // run only once
  });

  var timeout;
  $scope.reloadComments = function(showSkeleton) {
    $scope.threadRequestInProgress = true;
    if (showSkeleton) $scope.showSkeleton = true;

    var unbind = $rootScope.$on('thread-stats', function() {
      $scope.threadRequestInProgress = false;
      $scope.showSkeleton = false;
      unbind();
    });

    Notifs.fetch();

    return CommentService.getThread({
      offset: CommentService.page===1 ?
        CommentService.page * ($scope.firstLoadCount > 0 ? $scope.firstLoadCount:$scope.countPerPage)
        :$scope.firstLoadCount > 0 ? (CommentService.page * $scope.countPerPage)+ $scope.firstLoadCount - $scope.countPerPage: CommentService.page * $scope.countPerPage,
      limit: $scope.countPerPage,
    });
  };

  $scope.reloadCommentsDebounced = _.debounce($scope.reloadComments, 1000, true);

  $scope.reloadAllComments = function() {
    mixpanel.track('comments:reload_all');
    $rootScope.yakli = null;
    CommentService.resetAll();
    $scope.reloadComments(true);
  };

  $scope.showMore = function() {
    FocusService.desactivate();
    mixpanel.track('comments:show_more');
    return $scope.reloadCommentsDebounced(true);
  };

  /**
   * Only work if there is a yakli
   */
  $scope.fetchAndAppendComments = function(prepend) {
    $scope.threadRequestInProgress = true;
    $scope.showSkeleton = true;
    if (prepend) $scope.showSkeletonBefore = true;

    var unbind = $rootScope.$on('thread-stats', function() {
      $scope.threadRequestInProgress = false;
      $scope.showSkeleton = false;
      $scope.showSkeletonBefore = false;
      unbind();
    });

    return CommentService.getThread({
      offset: prepend ? $rootScope.yakli.pos_prev - $rootScope.yakli.prev : $rootScope.yakli.pos_next,
      limit: prepend ? $rootScope.yakli.prev : $rootScope.yakli.next,
    }).success(function() {
      $rootScope.newComments = [];
      FocusService.desactivate();

      if (prepend) {
        // no more comments
        if ($rootScope.yakli.total_prev === $rootScope.yakli.prev) {
          $rootScope.yakli.prev = 0;
          $rootScope.yakli.pos_prev = 0;
          $rootScope.yakli.total_prev = 0;
        }
        // update count
        else {
          $rootScope.yakli.total_prev -= $rootScope.yakli.prev;
          $rootScope.yakli.pos_prev -= $rootScope.yakli.prev;
          $rootScope.yakli.prev = Math.min($rootScope.yakli.total_prev, 20);
        }
      }
      else {
        // no more comments
        if ($rootScope.yakli.total_next === $rootScope.yakli.next) {
          $rootScope.yakli.next = 0;
          $rootScope.yakli.pos_next = 0;
          $rootScope.yakli.total_next = 0;
        }
        // update count
        else {
          $rootScope.yakli.total_next -= $rootScope.yakli.next;
          $rootScope.yakli.pos_next += $rootScope.yakli.next;
          $rootScope.yakli.next = Math.min($rootScope.yakli.total_next, 20);
        }
      }
    });
  };


  // Notifs
  // --------

  $scope.Notifs = Notifs;

  $scope.availableNotifs = [
    'pinned', 'voted', 'replied', 'ecd', 'reward', 'complete', 'reco',
  ];

  $scope.notifIcons = {
    'reward': 'gcicon-star',
    'pinned': 'gcicon-pin',
    'voted': 'gcicon-thumb-up',
    'replied': 'gcicon-comments',
    'ecd': 'gcicon-editorialized',
  };

  $scope.notifText = function(notif) {
    return $translate.instant('notifs.' + notif.action, {
      thread: notif.thread && `<b>${$filter('truncate')(notif.thread.page_title, 40)}</b>`,
      username: notif.user && '<b>' + notif.user.username + '</b>',
      fromUsername: notif.from_user && '<b>' + notif.from_user.username + '</b>',
      page: '<b>' + CommentService.website.name + '</b>',
    });
  };

  $scope.notifLink = function(notif) {
    if (['reward', 'complete', 'reco'].indexOf(notif.action) !== -1) return;
    return Utils.appendGetParam(notif.thread.url, 'comment_id=' + notif.comment._id);
  };

  $scope.notifIcon = function(notif) {
    if (notif.action === 'voted') {
      return notif.vote && Utils.voteIcon(notif.vote.score);
    }
    else if (notif.action === 'reward') {
      return `
        <span class="gc-reward-badge ${notif.reward.type}">
          <span class="gc-reward-icon ${notif.reward.type}"></span>
          ${$filter('capitalize')(notif.reward.name)}
        </span>
      `;
    }
    else {
      return `<i class="${$scope.notifIcons[notif.action]}"></i>`;
    }
  }

  $scope.notifAvatar = function(notif) {
    if (['voted', 'reward'].indexOf(notif.action) !== -1) {
      return GcUser.getUser();
    }
    else if (notif.action === 'reco') {
      return notif.from_user;
    }
    else {
      return notif.user;
    }
  };

  $scope.isNotifOnDifferentPage = function(notif) {
    if (['reward', 'complete', 'reco'].indexOf(notif.action) !== -1) return;
    return notif.thread._id !== CommentService.thread._id;
  };

  $scope.onNotifClick = function(event, notif) {
    if (!notif.view) $scope.markNotifView(notif);

    // open profile
    if (notif.action === 'reward') {
      $scope.openProfilePopin(null, GcUser.getUser()._id, { fromMenu: true, fullProfile: true });
      $scope.notifPanelOpen = false;
    } else if (notif.action === 'complete') {
      $scope.openProfilePopin(null, GcUser.getUser()._id, { fromMenu: true });
      $scope.notifPanelOpen = false;
    } else if (notif.action === 'reco') {
      $scope.openProfilePopin(null, GcUser.getUser()._id, { fromMenu: true, editBio: true });
      $scope.notifPanelOpen = false;
    } else {
      $timeout(function() {
        $scope.notifPanelOpen = false;
      }, 200);

      // scroll to comment
      if (!$scope.isNotifOnDifferentPage(notif)) {
        event.preventDefault();
        CommentService.populate(notif.comment._id).then(cmt => {
          scrollToComment(cmt._id, { timeout: 1000 });
        });
      }
    }
  };

  $scope.markNotifView = function(notif) {
    Notifs.updateViews([notif._id]);
  };

  $scope.markAllAsRead = function() {
    $scope.showNotifsLoader = true;
    Notifs.updateViews($scope.unviewedNotifs().map(n => n._id)).then(function() {
      $scope.showNotifsLoader = false;
    });
  };

  $scope.unviewedNotifs = function() {
    return Notifs.notifs && Notifs.notifs.filter(n => !n.view && $scope.availableNotifs.indexOf(n.action) !== -1);
  };

  $scope.toggleNotifs = function() {
    $scope.notifsVisible = [];
    $scope.notifPanelOpen = !$scope.notifPanelOpen;
    if (!$scope.notifPanelOpen) return;

    $scope.notifsPage = 0;
    $scope.loadMoreNotifs();
    Notifs.fetch();

    var pos = document.querySelector('.gc-notif i').getBoundingClientRect();
    var bodyMargin = document.querySelector('.gc-body').getBoundingClientRect().left;

    $scope.notifsPos = {
      top: pos.top + pos.height + 12 + 'px',
    };

    if ($rootScope.rtl) {
      $scope.notifsPos.left = document.body.offsetWidth > 500
        ? pos.left - bodyMargin - 60 + 'px'
        : '10px'
    } else {
      $scope.notifsPos.right = document.body.offsetWidth > 500
        ? document.body.offsetWidth - bodyMargin - pos.right - pos.width / 2 - 20 + 'px'
        : '10px'
    }
  };

  $scope.loadMoreNotifs = function() {
    $scope.notifsPage++;
    $scope.notifsVisible = Notifs.notifs.slice(0, 10 * ($scope.notifsPage + 1));
  };

  // lazy-load notifs while scrolling
  $rootScope.$on('gc:ready', function() {
    if (GcUser.getUser()) {
      CommentService.postSavedComment();
    }

    $timeout(function() {
      var $scroll = $('.gc-notif-panel-list');
      var customScrollbar = $scroll.data('custom-scrollbar');

      $scroll.on('custom-scroll', function() {
        if (customScrollbar.scroll().ratio.y > .8) {
          $scope.loadMoreNotifs();
          $scope.$apply();
        }
      });
    });
  });

  $document.on('click', function(event) {
    if (
      $scope.notifPanelOpen &&
      !document.querySelector('.gc-notif-panel').contains(event.target) &&
      !document.querySelector('.gc-notif').contains(event.target)
    ) {
      $scope.toggleNotifs();
    }
  });

  $rootScope.$on('gc:ready', function() {
    if (CommentService.website.notification) {
      $scope.notificationEnabled = true;
      var notifsWsEnabled = CommentService.website.websocket.notification;
      Notifs.init(notifsWsEnabled);

      if (!notifsWsEnabled) {
        // long polling
        setInterval(function() {
          if (Utils.pageVisible()) Notifs.fetch();
        }, 60 * 1000);
      }
    }
  });

  $rootScope.$on('notif', function(event, notif) {

    switch (notif.action) {
      case 'voted':
        // refresh votes
        CommentService.getComment(notif.comment._id).success(function(resp) {
          var node = resp[0];
          var rootNode = CommentService.getRootComment(node._id);

          var rootIndex = CommentService.comments.findIndex(cmt => cmt._id === rootNode._id);

          if (rootIndex !== -1) {

            // find child comment
            function findCmt(cmt, cmtId, cb) {
              if (cmt._id === cmtId) cb(cmt);
              else cmt.child_comments.forEach(c => findCmt(c, cmtId, cb));
            }

            findCmt(rootNode, node._id, function(cmt) {
              cmt.voters = node.voters;
              CommentService.computeVotes(cmt);
            });
          }
        });
        break;
      default:
        break;
    }
  });


  // New comments (WS)
  // (live feed)
  // -----------------

  $rootScope.newComments = [];

  function appendNewComment(cmt) {

    if (!$rootScope.newComments.find(c => c._id === cmt._id)) {
      // ignore if comment is a child comment
      if (cmt.parent_id) {
        // we add a timeout, because we want to be sure the notif is added first
        $timeout(function() {
          CommentService.append(cmt);
        });

        // if the parent is a new comment too,
        // we skip as the child will be visible directly under its parent
        if ($rootScope.newComments.find(c => c._id === cmt.parent_id)) return;

        // in case we dont want to have live replies in the feed
        if (Utils.getParameterByName('disable_live_replies') && Utils.getParameterByName('disable_live_replies') !== 'false') return;
      }
      
      if (CommentService._comments[cmt._id] && CommentService._comments[cmt._id].status === 'pending' &&  cmt.status === 'approved'){
        CommentService._comments[cmt._id].status = cmt.status;
      }

      // ignore if comment is already there
      if (CommentService._comments[cmt._id]) return;

      // ignore if comment is mine
      var user = GcUser.getUser();
      if (user && cmt.author && user._id === cmt.author._id) return;

      // ignore if comment is mine
      var guest = GcUser.getGuest();
      if (guest && cmt.guest && guest.email === cmt.cached_author.email) return;

      if ($rootScope.autoOpenNewComments && $scope.sorting === 'newest') {
        // directly append new comment
        cmt.isNew = true;
        cmt.isShown = true;
        CommentService.comments.unshift(cmt);
      } else {
        // show Twitter like notif
        $rootScope.newComments.unshift(cmt);
      }

      CommentService._comments[cmt._id] = cmt;
      CommentService.total_comments++;

      if ($scope.sorting === 'newest') $scope.computeLastCommentRead();
    }
  }

  $rootScope.$on('thread', function(event, thread) {
    var website = CommentService.website;
    if (!website.websocket || !website.websocket.notification) return;

    function onMsg(data) {
      var cmt = data.msg;
      appendNewComment(cmt);
    }

    function onOpen(event) {
      // join channel
      this.send(JSON.stringify({ joinThread: CommentService.thread_id }));
    }

    var ws = WS.create(onMsg, onOpen);

    // only keep new comments under 10 minutes
    setInterval(function() {
      var threshold = moment().subtract(10, 'minutes');
      //var threshold = moment().subtract(1, 'minute');
      $rootScope.newComments.forEach(function(cmt) {
        if (cmt.isShown) return; // skip for visible comments
        if (moment(cmt.created_at).isBefore(threshold)) {
          $rootScope.newComments.splice($rootScope.newComments.indexOf(cmt), 1);
        }
      });
    }, 60 * 1000); // every minute
  });

  /*
   * Websocket connection closes when we leave the page
   * When user come back to the page we fetch comments since he left
   */
  $rootScope.$on('gc:ready', function() {
    var wasHiddenSince;
    var notifsWsEnabled = CommentService.website.websocket.notification;
    var loadTime = new Date();

    setInterval(function() {
      // user just came back to GC
      if (Utils.pageVisible() && wasHiddenSince) {
        // if websockets are disabled instead of fetching since user left,
        // we fetch since user has initially loaded the page
        if (!notifsWsEnabled) {
          wasHiddenSince = loadTime;
          loadTime = new Date();
        }

        CommentService.getLastComments(wasHiddenSince).then(function(resp) {
          resp.data.forEach(function(cmt) {
            appendNewComment(cmt);
          });
        });
        wasHiddenSince = null;
      }

      if (!Utils.pageVisible() && !wasHiddenSince) {
        wasHiddenSince = new Date();
      }
    }, 2 * 1000);
  });

  $scope.showNewComments = function() {
    if (!$rootScope.newComments.length) return;

    if ($scope.sorting === 'newest') {
      $rootScope.newComments.forEach(function(c) {
        c.isNew = true;
        c.isShown = true;
      });

      CommentService.comments.unshift(...$rootScope.newComments);

      $scope.computeLastCommentRead();
      $rootScope.lastCommentRead = LocalStorageService.getItem('last_comment_read_' + CommentService.thread._id);
      LocalStorageService.setItem('last_comment_read_' + CommentService.thread_id, $rootScope.newComments[0]._id);
    } else {
      $scope.setSort('newest');
    }

    $rootScope.newComments = [];
  };

  $scope.getNewCommentsNotOpened = function() {
    return $rootScope.newComments.filter(c => !c.isShown);
  };

  $scope.getNewCommentsOpened = function() {
    return $rootScope.newComments.filter(c => c.isShown);
  };


  // Last comment read
  // --------------------------------

  /**
   * Calculate informations wether we should display:
   * - an horizontal line to indicate last comment we read
   * - a notice if the horizontal line is outside viewport
   */
  $scope.computeLastCommentRead = function() {
    if($rootScope.searchMode)return;
    var lastCommentRead = $rootScope.lastCommentRead;
    $log.debug('last comment read', lastCommentRead);

    if (!lastCommentRead || $rootScope.yakli) {
      $scope.lastCommentReadLine = false;
      $scope.lastCommentReadLineInViewport = false;
      return;
    }

    // if comment not yet loaded, load it
    if (!CommentService._comments[lastCommentRead]) {

      // dont load more than 100 comments
      if (CommentService.comments.length > 100) {
        $scope.lastCommentReadLine = false;
        $scope.lastCommentReadLineInViewport = false;
        return;
      }

      if ($scope.lastCommentReadLoading) return;
      $scope.lastCommentReadLoading = true;
      $scope.showMore().then(function() {
        $scope.lastCommentReadLoading = false;
        var unbind = $rootScope.$on('thread-stats', function() {
          unbind();
          $scope.computeLastCommentRead();
        });
      });
      return;
    }

    $scope.lastCommentReadIndex = CommentService.comments.findIndex(c => c._id === lastCommentRead);
    $scope.lastCommentReadCount = $scope.lastCommentReadIndex + $rootScope.newComments.length;
    $scope.lastCommentReadDate = CommentService._comments[lastCommentRead].updated_at;

    $scope.lastCommentReadLine = (
      $scope.sorting === 'newest' &&
      $scope.lastCommentReadIndex !== -1 &&
      $scope.lastCommentReadIndex !== 0 &&
      $scope.lastCommentReadIndex < 50 && // dont show line if more than 50 comments (for perfs)
      $scope.lastCommentReadIndex !== CommentService.comments.length
    );

    $log.debug('last comment read line', $scope.lastCommentReadLine, $scope.lastCommentReadIndex, $scope.lastCommentReadDate);

    if (!$scope.lastCommentReadLine && !$rootScope.newComments.length) {
      $scope.lastCommentReadLineInViewport = false;
      return;
    }

    // wait for html element to be created before detecting if inside viewport
    $timeout(function() {
      var $comment = $('#comment-' + $rootScope.lastCommentRead);
      if (!$comment.length) return;

      var offsetTop = $comment.offset().top;
      var scroll = Utils.inIframe() && !Utils.inOverlay() ? $rootScope.iframeScroll.pos.top : Utils.getScrollPosition().top;
      var windowHeight = Utils.inIframe() && !Utils.inOverlay() ? $rootScope.iframeScroll.win.height : window.innerHeight;

      // due to a weird bug where offset() does not return the value,
      // we need to manually add the scroll offset
      if (Utils.inOverlay()) {
        var scrollData = window.overlayScrollbar.scroll();
        offsetTop += scrollData.position.y;
        scroll = scrollData.position.y;
      }

      // fix edge case where iframe is still loading but the notice is already showing
      if (windowHeight === 0) {
        $scope.lastCommentReadLineInViewport = true;
        return;
      }

      $scope.lastCommentReadLineAbove = offsetTop < scroll;
      $scope.lastCommentReadLineBelow = offsetTop - 20 > scroll + windowHeight;

      // dont show notice if there's only one new comment and we are already above the line
      if ($scope.lastCommentReadIndex === 1) $scope.lastCommentReadLineBelow = false;

      $scope.lastCommentReadLineInViewport = !$scope.lastCommentReadLineAbove && !$scope.lastCommentReadLineBelow;

      $scope.lastCommentReadNotice = (
        !$scope.lastCommentReadHasJumped &&
        $scope.lastCommentReadCount > 0 &&
        !$scope.lastCommentReadLineInViewport &&
        ($scope.lastCommentReadLine || $rootScope.newComments.length) &&
        $scope.sorting === 'newest'
      );

      $log.debug('last comment read notice', $scope.lastCommentReadLineInViewport, offsetTop, scroll, windowHeight);

      $scope.lastCommentReadLineStyle = Utils.inIframe() && !Utils.inOverlay() ? {
        top: scroll + windowHeight - 32 - 20,
        bottom: 'initial',
        display: 'flex',
      } : { display: 'flex' };
    }, 0);
  };

  $scope.jumpToLastCommentRead = function() {
    $scope.showNewComments();
    $scope.lastCommentReadHasJumped = true;

    var windowHeight = Utils.inIframe() && !Utils.inOverlay() ? $rootScope.iframeScroll.win.height : window.innerHeight;
    scrollToComment($rootScope.lastCommentRead, {
      offset: - windowHeight + 45,
      skipFocus: true
    });
  };

  $scope.resetLastCommentRead = function() {
    if (CommentService.comments.length) {
      $rootScope.lastCommentRead = CommentService.comments[0]._id;
      LocalStorageService.setItem('last_comment_read_' + CommentService.thread_id, $rootScope.lastCommentRead);
      $log.debug('last comment reset', $rootScope.lastCommentRead);
    }

    // reset all vars
    for (var k in $scope) {
      if (k.indexOf('lastCommentRead') === 0 && k !== 'lastCommentRead') {
        $scope[k] = null;
      }
    }
  };

  $scope.computeLastCommentReadDebounced = _.debounce($scope.computeLastCommentRead, Utils.isMobile() ? 1000 : 100);

  $rootScope.$on('gc:ready', function() {
    if ($scope.sorting === 'newest') {
      var thread = CommentService.thread;
      var firstComment = thread.child_comments[0];

      $rootScope.lastCommentRead = LocalStorageService.getItem('last_comment_read_' + thread._id);

      if (firstComment && !$rootScope.yakli) {
        // ignore if iframe is hidden (because in overlay mode)
        if (!Utils.getParameterByName('hidden') || Utils.getParameterByName('hidden') === 'false') {
          // remember for next time that the lastCommentRead is the first one loaded
          LocalStorageService.setItem('last_comment_read_' + thread._id, firstComment._id);
        }
        if (!$rootScope.lastCommentRead) {
          $rootScope.lastCommentRead = firstComment._id;
        }
      }
    }

    $rootScope.$watch('lastCommentRead', function watchLastCommentRead() {
      $scope.computeLastCommentRead();
    });

    $(window).on('resize', $scope.computeLastCommentReadDebounced);

    if (window.overlayScrollbar) {
      window.onOverlayScroll = $scope.computeLastCommentRead;
    } else {
      window.addEventListener('scroll', $scope.computeLastCommentReadDebounced);
    }
  });

  if (!$rootScope.isWidget) {
    $rootScope.$on('gc:ready', function() {
      var observer = new IntersectionObserver(function(entries) {
        var isViewportAboveFirstComment = entries[0].isIntersecting
        $rootScope.isViewportAboveFirstComment = isViewportAboveFirstComment;
        $rootScope.autoOpenNewComments = isViewportAboveFirstComment;

        if (isViewportAboveFirstComment && $scope.lastCommentReadHasJumped) {
          $scope.lastCommentReadHasJumped = false;
          $scope.resetLastCommentRead();
        }
      });
      if(!$rootScope.readonly) {
        observer.observe(document.querySelector('.gc-creator'));
      }
    });
  }


  // -----------------------



  $rootScope.$on('scrolled-to-iframe', function() {
    spupLog('[spup] scrolled to iframe');

    try {
      window.dataLayer && window.dataLayer.push({ event: 'has-read-comments' });
    } catch (e) {}

    CommentService.waitForWebsite(function(website) {
      if (website.custom_client === 'orange') {
        $timeout(function() {
          spupLog('[spup] init spup (skip auth)');
          //window.parent.oSpup.get(true);
          window.parent.postMessage({"target": "spup", "command": "get", "params": [true]}, '*');
        }, 1000); // spup eventListeners are added in a timeout of 0ms, we put 100ms to be just after
      }
    });
  });

  // send 'gc-activity' event each time
  var sendActivity = _.debounce(function() {
    PostMessageService.postMessage('gc-activity');
  }, 10 * 1000, true);

  window.addEventListener('scroll', sendActivity);
  window.addEventListener('click', sendActivity);
  window.addEventListener('mousemove', sendActivity);
  window.addEventListener('touchstart', sendActivity);


  // comment scores debugging

  $rootScope.showCommentScores = LocalStorageService.getItem('show-comment-scores') || false;

  window.gcToggleCommentScores = function() {
    $rootScope.showCommentScores = !$rootScope.showCommentScores;
    LocalStorageService.setItem('show-comment-scores', $rootScope.showCommentScores);
  };

  // search
  $scope.openSearch = function(){
    $scope.searchClass = "gc-search-mode";
    CommentService.comments = [];
    $rootScope.searchMode = true;
  }

  $scope.closeSearch = function(){
    $scope.searchClass = "";
    $rootScope.searchMode = false;
    CommentService.comments = [];
    CommentService.search_comments = [];
    $scope.reloadAllComments();
  }

  $scope.closeSearchDetails = function(){
    $rootScope.modalFullScreen = false;
    $rootScope.$broadcast('comment:detail:close');
  }

}])

/**********************************************************************************************************************
* Graphcomment Directive
**********************************************************************************************************************/
.directive('graphcomment', [
'$http',
'$rootScope',
'$location',
'$timeout',
'$document',
'$log',
'API_URL',
'GcUser',
'GcECD',
'CommentService',
'Perfs',
'ShareService',
'getSearchParameters',
'BO_URL',
'LanguageUtils',
'LocalStorageService',
'PubService',
'PostMessageService',
'Utils',
'GraphLogin',
function ($http, $rootScope, $location, $timeout, $document, $log, API_URL, GcUser, GcECD, CommentService, Perfs,
          ShareService, getSearchParameters, BO_URL, LanguageUtils, LocalStorageService, PubService, PostMessageService, Utils, GraphLogin) {
  'use strict';
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'graph_comment_module.html',
    controller: 'GraphcommentController',
    link: function (scope, el) {
      scope.CommentService = CommentService;

      scope.Perfs = Perfs;
      scope.mainColorClass = '';
      scope.searchValue = '';
      scope.GcECD = GcECD;
      scope.bo_url = BO_URL;
      scope.bo_moderate_url = BO_URL;
      scope.mainThemeClass = Utils.getParameterByName('theme') === 'dark' ? 'gc-theme-dark' : 'gc-theme-light';

      $rootScope.$on('logged_in', function () {
        if (GcUser.hasPrivileges()) {
          CommentService.waitForThread(function(thread) {
            var website = CommentService.website;
            scope.bo_url = BO_URL + '/#/website/' + website._id + '/graphcomment';
            scope.bo_moderate_url = BO_URL + '/#/website/' + website._id + '/graphcomment?tags=thread_id:' + thread._id + '&tab=all';
          });
        }
      });

      $rootScope.ieCompatibilityBox = false;
      $rootScope.gcReady = false;

      if (!window.location.origin) {
        // Some browsers (mainly IE) does not have this property, so we need to build it manually...
        window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
      }

      var params = getSearchParameters();
   
      LanguageUtils.init();
      
      // Init the hosting page language (passed from integration.js)
      if (params.lang) LanguageUtils.lang = params.lang;

      // Detect touch capability of the browser
      if ('ontouchstart' in document.documentElement) {
        document.documentElement.className += ' gc-touch';
      } else {
        document.documentElement.className += ' gc-no-touch';
      }

      // Detect when the iframe size changes and send it to parent
      var oldHeight = 0;
      setInterval(function () {
        var $popins = document.querySelectorAll('.gc-popin, .gc-vote, .gc-notif-panel');
        var popins = [].slice.call($popins);

        var popinHeights = popins.map(function(popin) {
          if (getComputedStyle(popin).display !== 'none') {
            // only for bbf3d
            if (popin.classList.contains('gc-all-answers-inner')) {
              var rect = popin.getBoundingClientRect();
              var marginBottom = Number(getComputedStyle(popin)['margin-bottom'].replace('px', ''));
              return rect.top + rect.height + marginBottom;
            }

            var rect = popin.getBoundingClientRect();
            return rect.top + rect.height;
          }

          return 0;
        });

        var maxPopinHeight = Math.max(...popinHeights);
        var newHeight = Math.max(document.body.offsetHeight, maxPopinHeight + 20);

        if (newHeight !== oldHeight && window.parent) {
          PostMessageService.postMessage('gc-height', {
            height: Math.ceil(newHeight)
          });

          // for amp-iframe
          window.parent.postMessage({ sentinel: 'amp', type: 'embed-size', height: newHeight }, '*');

          oldHeight = newHeight;
        }
      }, Utils.isMobile() ? 1000 : 200);


      // Reset oldHeight if parent is load after iframe
      window.addEventListener('message', function(e) {
        // var isSlave = isAuthSlave();

        // if (isSlave) {
          var authData  = e.data || {};

          switch(authData.type) {
            case '__semiologic__TOKEN_EXCHANGE__semiologic__':
              if (authData.token) {
                CommentService.waitForWebsite(function(website) {
                  GcUser.refresh(authData.token);
                });

              } else {
                GcUser.oldLogout($rootScope.disableTrackingOnLogout);
                $rootScope.disableTrackingOnLogout = false;
              }
              return;

            default:
              break;
          }
        // }
        try {
          var data = JSON.parse(e.data || null);
        } catch (e) {
          // for angularjs batarang chrome extension
          return;
        }

        if (!data || !data.info) return;

        switch (data.info) {
          case 'parent_loaded':
            oldHeight = 0;
            break;
          case 'on_viewport':
            $rootScope.$broadcast('scrolled-to-iframe');
            break;
          case 'sso-logout':
            GcUser.logout();
            break;
          case 'sso-login':
            CommentService.waitForWebsite(function(website) {
              GcUser.sso(data.data);
            });
            break;
          case 'fixed-header-height':
            $rootScope.fixedHeaderHeight = data.height;
            break;
          case 'scroll-start': {
            var $notice = document.querySelector('.gc-last-comment-read-notice');
            if ($notice) $notice.style.display = 'none';
          }
          case 'scroll-end':
            $rootScope.iframeScroll = data;
            CommentService.waitForThread(scope.computeLastCommentReadDebounced);
            break;
          /*
          @fix : vulnerability xss, activer que pour debug.
          case  'cmd': {
            var cmd = window[data.cmd];
            if (cmd && typeof cmd === 'function') {
              cmd.apply(window, data.args);
            }
            break
          } */
          case 'gc_token':
            CommentService.waitForWebsite(function(website) {
              var token = decodeURIComponent(data.token);
              GcUser.refresh(token);
            });
            break;
          case 'gc_visible':
                if(!CommentService.thread_id){
                  $rootScope.$on('thread', ()=>{
                    PubService.sendAudience(CommentService.thread_id)
                  })
                  return
                }
                PubService.sendAudience(CommentService.thread_id)
              break;
          case 'gc_ad_orange':
            window.o_idzone = data.o_idzone;
            break;
          case 'gc_ad_tcfapi':
            window.tcdata = data.__tcfapi;
            break;
          default:
            break;
        }
      });

      // send an event to integration.js to tell GC is loaded
      PostMessageService.postMessage('gc-loaded');

      // lazy loading
      $rootScope.$on('gc:ready', function() {
        $rootScope.gcReady = true;

        PostMessageService.postMessage('gc-ready');

        if (scope.lazyLoading && 'IntersectionObserver' in window) {
          var observer = new IntersectionObserver(function(entries) {
            var yakli = Utils.getParameterByName('comment_id');
            // disable while showing a yakli
            if ($rootScope.yakli) return;

            if (entries[0].isIntersecting && CommentService.comments.length && !scope.threadRequestInProgress) {
              scope.showMore();
              scope.$apply();
            }
          });
          var $showMore = el[0].querySelector('.gc-btn-show-more');
          if ($showMore) {
            observer.observe($showMore);
          }
        }
      });

      // Detect emoji capability of the
      function doesSupportEmoji() {
        var context, smiley;
        if (!document.createElement('canvas').getContext) return;
        context = document.createElement('canvas').getContext('2d');
        if (typeof context.fillText != 'function') return;
        var smile = String.fromCharCode(55357) + String.fromCharCode(56835);
        context.textBaseline = "top";
        context.font = "32px Arial";
        context.fillText(smile, 0, 0);
        return context.getImageData(16, 16, 1, 1).data[0] !== 0;
      }

      Perfs.measure('bootstrap');
      $rootScope.spupLog('fetch website');

      CommentService.getWebsite(params.website_id || 'dev-site-graphcomment')
        .success(function (website) {
          // before we we're using "count_per_page:0" for lazy-loading
          // but now we have a separate setting for enabling lazy-loading
          // so for users with an old value of 0, we still enable lazy-loading
          scope.lazyLoading = (CommentService.website.count_per_page === 0) || CommentService.website.lazy_load;
          $rootScope.isSso = CommentService.website.sso.active;
          scope.countPerPage = scope.lazyLoading
            ? 10
            : (Utils.getParameterByName('count_per_page') || CommentService.website.count_per_page)
          ;

          scope.firstLoadCount = Utils.getParameterByName('first_load_count') || CommentService.website.first_load_count;

          // dont allow values bigger than 10k
          if (scope.countPerPage > 10e3) scope.countPerPage = 10e3;

          // dont allow values bigger than 10k
          if (scope.firstLoadCount > 10e3) scope.firstLoadCount = 10e3;

          if (Utils.getParameterByName('disable_lazy_loading') !== undefined) {
            scope.lazyLoading = false
            scope.countPerPage = 10
          }

          // Init the color
          scope.mainColorClass = website.color ? 'gc-theme-' + website.color : '';

          // Init light or dark theme
          if (website.theme === 'auto') {
            scope.mainThemeClass = 'gc-theme-' + (Utils.getParameterByName('theme') || 'light');
          } else {
            scope.mainThemeClass = 'gc-theme-' + website.theme;
          }

          // to debug dark/light themes
          window.gcDarkTheme = function() {
            scope.mainThemeClass = 'gc-theme-dark';
            document.body.style.background = '#222';
          };
          window.gcLightTheme = function() {
            scope.mainThemeClass = 'gc-theme-light';
            document.body.style.background = '#fff';
          };
          
          fetchUser();
        
        })
        .error(function(resp, status, config) {
          if (status === 404) {
            $rootScope.gcReady = true;
            $rootScope.websiteNotFound = true;
          } else {
            loadingError('website', resp, status, config);
          }
        });

      function fetchUser() {
        $rootScope.spupLog('fetch user');
        GcUser.init(function(user) {
          if (Utils.getParameterByName('pagination') && Utils.getParameterByName('pagination') === 'all') {
            scope.countPerPage = 10e3;
          }

          // init more stuff
          if (user) scope.connectedUser = user;
          if (user) CommentService.initDataVote(user);
          scope.initSorting(user);
          LanguageUtils.updateUILanguage();

          // check if user has a profile, else open profile
          // and force user to fill his/her profile
          if (user && !user.profile_found) {
            if (CommentService.website.custom_client !== 'orange') {
              $rootScope.$broadcast('profile-popin:open', user._id, { fromMenu: true });
            }
          }

          fetchThread();
      
        });
      }

      function fetchThread() {
        $rootScope.spupLog('fetch thread');
        var yakli = Utils.getParameterByName('comment_id');

        CommentService.init({
          offset: 0,
          limit: scope.firstLoadCount || scope.countPerPage,
          comment_id: yakli,
        })
          .success(function () {
            var yakli = Utils.getParameterByName('comment_id');
            if (yakli) {
              var thread = CommentService.thread;

              // yakli not found
              if (thread.pos_yakli === -1) {
                $rootScope.yakliNotFound = true;
                console.error('[gc] yakli ' + yakli + ' not found');
                return;
              }

              // compute yakli pagination
              var total_next = thread.total_root_comments - thread.pos_yakli - 1;
              $rootScope.yakli = {
                pos: thread.pos_yakli,

                prev: thread.pos_yakli > 20 ? 20 : thread.pos_yakli,
                total_prev: thread.pos_yakli,
                pos_prev: thread.pos_yakli,

                next: total_next > 20 ? 20 : total_next,
                total_next,
                pos_next: thread.pos_yakli + 1,
              };

              // open conversation
              // (from yakli, all the way to the root comment)
              var cmt = CommentService._comments[yakli];
              cmt.active = true;
              while (cmt.parent_id) {
                cmt = CommentService._comments[cmt.parent_id];
                cmt.active = true;
              }

              $rootScope.skipLayout = Utils.getParameterByName('skip_layout');
            }

          })
          .error(function(resp, status, config) {
            if (resp && resp.type === 422 && resp.msg === 'unknown websiteId') {
              $rootScope.gcReady = true;
              $rootScope.websiteNotFound = true;
            } else {
              loadingError('thread', resp, status, config);
            }
          });


      }

      function loadingError(type, error, status, config) {
        $rootScope.loadingError = true;
        mixpanel.track('loading_error', {
          type,
          status,
          url: config.url,
          method: config.method,
          error: error ? JSON.stringify(error) : 'no error returned',
        });
      }

      $rootScope.reloadPage = function() {
        window.location.reload();
      }

    }
  };
}]);
